/**
 * The authentication-outcome duration buckets, exactly as `contracts/telemetry.md` defines them.
 * `le_3s` is the SC-002 boundary (inclusive of 3,000 ms). Kept free of imports so boot code can
 * bucket a duration without loading the analytics graph that `events.ts` pulls in.
 */
export const AUTHENTICATION_OUTCOME_DURATION_BUCKETS = ['le_3s', 'gt_3s_le_10s', 'gt_10s', 'unknown'] as const;
export type AuthenticationOutcomeDurationBucket = (typeof AUTHENTICATION_OUTCOME_DURATION_BUCKETS)[number];

/** Buckets a monotonic duration in milliseconds; a negative or non-finite one is `unknown`. */
export function bucketAuthenticationOutcomeDuration(durationMs: number): AuthenticationOutcomeDurationBucket {
  if (!Number.isFinite(durationMs) || durationMs < 0) return 'unknown';
  if (durationMs <= 3_000) return 'le_3s';
  if (durationMs <= 10_000) return 'gt_3s_le_10s';
  return 'gt_10s';
}
